import { render, staticRenderFns } from "./Salegoods.vue?vue&type=template&id=a9adc784&"
import script from "./Salegoods.vue?vue&type=script&lang=js&"
export * from "./Salegoods.vue?vue&type=script&lang=js&"
import style0 from "./Salegoods.vue?vue&type=style&index=0&id=a9adc784&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a9adc784')) {
      api.createRecord('a9adc784', component.options)
    } else {
      api.reload('a9adc784', component.options)
    }
    module.hot.accept("./Salegoods.vue?vue&type=template&id=a9adc784&", function () {
      api.rerender('a9adc784', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/general/Salegoods.vue"
export default component.exports